import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import { apiHalper } from '../../helpers/ApiHelper';
import { jwtDecode } from '../../helpers/jwt_helper';
import Select from 'react-select';
import moment from 'moment';
import DatePicker from 'react-datepicker'
import Resume_icon from '../../assets/images/resume_icon.svg';
import LoaderImg from '../../assets/images/user-loader.gif';
import ConfirmModal from '../ConfirmModal';
import { toster_error, toster_sucess } from '../../helpers/toster_helper';

class ProfileTab extends Component {
    _unmounted = false
    constructor(props) {
        super(props);
        this.state = {
            isType: '',
            isUserProModal: false,
            isUserLoader: false,
            userError: '',
            isEdit: false,
            userDetails: [],
            allLang: [],
            allLangBack: [],
            skillsCount: 0,
            isSkillSLoader: true,
            isSkillAPILoader: false,
            isPrevSearchSkill: false,
            allSkill: [],
            allSkillBack: [],
            pageSkill: 1,
            searchSkill: '',
            agentSkills: [],
            editSkill: null,
            editLang: null,
            isLangLoader: false,
            langErr: '',
            selectedLanglist: [],
            degree: '',
            university: '',
            startDate: '',
            endDate: '',
            firstname: '',
            lastname: '',
            username: '',
            email: '',
            password: '',
            countryCode: '',
            mobile: '',
            mobileError: '',
            mobileValid: false,
            eduFormError: {
                degree: '',
                university: ''
            },
            eduFormValid: {
                degree: false,
                university: false
            },
            formError: {
                firstname: '',
                lastname: '',
                username: '',
                email: '',
                password: '',
            },
            formValid: {
                firstname: false,
                lastname: false,
                username: false,
                email: false,
                password: false
            },
            isAddLang: false,
            langArray: [],
            selectLang: [],
            langLevel: [],
            eduLevel: [],
            isExpertise: false,
            headline: '',
            summary: '',
            isHeadline: false,
            isSummary: false,
            isELoader: false,
            isESLoader: false,
            expErr: '',
            expertArr: [],
            optionsExp: [],
            defaultExpert: null,
            editExpert: null,
            selectExpert: null,
            selectExp: null,
            isSkillsO: false,
            selectSkills: null,
            sSkillsLevel: null,
            isSLoader: false,
            skillErr: '',
            officeBaseVal: null,
            homeBaseVal: null,
            fixedPrice: null,
            hourPrice: null,
            partTime: null,
            fullTime: null,
            freeA: null,
            isEHistory: false,
            isEducation: false
        }
    }

    getQueryStringUrl = () => {
        const { location: { search } } = this.props
        var url = new URLSearchParams(search)
        this.setState({
            isType: url.get("type")
        })
        return url.get("type")
    }

    componentDidMount() {
        this._unmounted = true;
        const type = this.getQueryStringUrl();
        if (type === "agents")
            this.getViewAgentProfile()
        if (type === "clients")
            this.getViewClientProfile()
        this.getLanguages();

        const optionsExp = [
            { label: 'Less than 1 year', value: 0 },
            { label: '1-3 years', value: 1 },
            { label: '4-6 years', value: 2 },
            { label: '7-9 years', value: 3 },
            { label: '10-12 years', value: 4 },
            { label: '13-15 years', value: 5 },
            { label: '16-18 years', value: 6 },
            { label: '19-21 years', value: 7 },
            { label: '22-24 years', value: 8 },
            { label: '25-27 years', value: 9 },
            { label: '28-30 years', value: 10 },
            { label: '31+ years', value: 11 }
        ]

        if (this._unmounted) {
            this.setState({
                optionsExp: optionsExp
            })
        }
    }

    componentWillUnmount() {
        this._unmounted = false
    }

    // getSnapshotBeforeUpdate(prevProps, prevState) {
    //     if (prevState.searchSkill !== this.state.searchSkill) {
    //         this.setState({
    //             isPrevSearchSkill: true,
    //             allSkill: [],
    //             allSkillBack: []
    //         })
    //     }

    //     return null;
    // }

    componentDidUpdate(prevProps, prevState, snapshot) {

        // if (snapshot !== null) { }

        // const { userDetails } = this.props;
        // console.log(userDetails.first_name)
        // if (userDetails !== prevProps.userDetails) {
        //     // console.log(userDetails);
        //     const { contact_no } = userDetails;

        //     const code = contact_no === null ? null : userDetails.contact_no.split('.');
        //     // if()
        //     // console.log(code);
        //     if (code === null) {
        //         this.setState({
        //             mobile: '',
        //             mobileError: '',
        //             mobileValid: false,
        //         })
        //     } else {
        //         this.setState({
        //             mobile: code[0] + ' ' + code[1],
        //             mobileError: '',
        //             mobileValid: true,
        //         })
        //     }
        //     console.log(userDetails.first_name)
        //     if (Array.isArray(userDetails) && userDetails.length > 0) {
        //         this.setState({
        //             firstname: userDetails.first_name,
        //             lastname: userDetails.last_name,
        //             username: userDetails.username,
        //             email: userDetails.email,
        //             password: '',
        //             formError: {
        //                 firstname: '',
        //                 lastname: '',
        //                 username: '',
        //                 email: '',
        //                 password: ''
        //             },
        //             formValid: {
        //                 firstname: true,
        //                 lastname: true,
        //                 username: true,
        //                 email: true,
        //                 password: true,
        //             },
        //             headline: userDetails.headlines === null ? '' : userDetails.headlines,
        //             summary: userDetails.summaries === null ? '' : userDetails.summary,
        //             fixedPrice: userDetails.profile_pay_types[0].status,
        //             hourPrice: userDetails.profile_pay_types[1].status,
        //             partTime: userDetails.profile_pay_types[2].status,
        //             fullTime: userDetails.profile_pay_types[3].status,
        //             freeA: userDetails.profile_pay_types[4].status
        //         });
        //         switch (userDetails.workbase) {
        //             case '0':
        //                 this.setState({
        //                     officeBaseVal: 1,
        //                     homeBaseVal: 0
        //                 })
        //                 break;
        //             case '1':
        //                 this.setState({
        //                     officeBaseVal: 0,
        //                     homeBaseVal: 1
        //                 })
        //                 break;
        //             case '2':
        //                 this.setState({
        //                     officeBaseVal: 1,
        //                     homeBaseVal: 1
        //                 })
        //                 break;
        //             case '3':
        //                 this.setState({
        //                     officeBaseVal: 0,
        //                     homeBaseVal: 0
        //                 })
        //                 break;
        //             default:
        //                 break;
        //         }
        //     }
        // }
        // this.getLangApi();
    }

    getViewClientProfile = async () => {
        try {

            this.setState({
                isLoader: true
            });

            const headers = {
                'Authorization': sessionStorage.getItem('token')
            }

            const { id } = this.props.match.params;

            let formData = new FormData();
            formData.append('profile_id', id)

            const response = await apiHalper('viewClientProfile', 'POST', formData, headers)
            const res = response.data;

            if (res.status) {
                const data = jwtDecode(res.data);
                console.log(data)
                let mobile_no = '';
                let countryCode1 = '';
                if (data && data.contact_no) {
                    const mobile_no1 = data.contact_no.split('.');
                    countryCode1 = mobile_no1;
                    mobile_no = mobile_no1.join(' ')
                }
                else {
                    mobile_no = ''
                }

                this.setState({
                    isLoader: false,
                    userDetails: data,
                    firstname: data.first_name,
                    lastname: data.last_name,
                    username: data.username,
                    password: '',
                    selectedLanglist: data.language,
                    formError: {
                        firstname: '',
                        lastname: '',
                        username: '',
                        email: '',
                        password: ''
                    },
                    formValid: {
                        firstname: true,
                        lastname: true,
                        username: true,
                        email: true,
                        password: true,
                    },
                    countryCode: countryCode1,
                    mobile: mobile_no,
                    email: data.email,
                    headline: data.headlines,
                    summary: data.summaries,
                    // fixedPrice: data.profile_pay_types[0].status,
                    // hourPrice: data.profile_pay_types[1].status,
                    // partTime: data.profile_pay_types[2].status,
                    // fullTime: data.profile_pay_types[3].status,
                    // freeA: data.profile_pay_types[4].status,
                    // agentSkills: data.skills,
                    // defaultExpert: data.expertise
                })

                console.log(this.state.username)
                switch (data.workbase) {
                    case '0':
                        this.setState({
                            officeBaseVal: 1,
                            homeBaseVal: 0
                        })
                        break;
                    case '1':
                        this.setState({
                            officeBaseVal: 0,
                            homeBaseVal: 1
                        })
                        break;
                    case '2':
                        this.setState({
                            officeBaseVal: 1,
                            homeBaseVal: 1
                        })
                        break;
                    case '3':
                        this.setState({
                            officeBaseVal: 0,
                            homeBaseVal: 0
                        })
                        break;
                    default:
                        break;
                }

            }
            else {
                this.setState({
                    isLoader: false
                });
            }

        } catch (err) {
            console.log(err.message);
        }
    }
    getViewAgentProfile = async () => {
        try {

            this.setState({
                isLoader: true
            });

            const headers = {
                'Authorization': sessionStorage.getItem('token')
            }

            const { id } = this.props.match.params;

            let formData = new FormData();
            formData.append('profile_id', id)

            const response = await apiHalper('viewAgentProfile', 'POST', formData, headers)
            const res = response.data;

            if (res.status) {
                const data = jwtDecode(res.data);
                let mobile_no = '';
                let countryCode1 = '';
                if (data && data.contact_no) {
                    const mobile_no1 = data.contact_no.split('.');
                    countryCode1 = mobile_no1[0];
                    mobile_no = mobile_no1.join(' ')
                }
                else {
                    mobile_no = ''
                }

                this.setState({
                    isLoader: false,
                    userDetails: data,
                    firstname: data.first_name,
                    lastname: data.last_name,
                    username: data.username,
                    password: '',
                    selectedLanglist: data.language,
                    formError: {
                        firstname: '',
                        lastname: '',
                        username: '',
                        email: '',
                        password: ''
                    },
                    formValid: {
                        firstname: true,
                        lastname: true,
                        username: true,
                        email: true,
                        password: true,
                    },
                    countryCode: countryCode1,
                    mobile: mobile_no,
                    email: data.email,
                    headline: data.headlines,
                    summary: data.summaries,
                    fixedPrice: data.profile_pay_types[0].status,
                    hourPrice: data.profile_pay_types[1].status,
                    partTime: data.profile_pay_types[2].status,
                    fullTime: data.profile_pay_types[3].status,
                    freeA: data.profile_pay_types[4].status,
                    agentSkills: data.skills,
                    defaultExpert: data.expertise
                });
                switch (data.workbase) {
                    case '0':
                        this.setState({
                            officeBaseVal: 1,
                            homeBaseVal: 0
                        })
                        break;
                    case '1':
                        this.setState({
                            officeBaseVal: 0,
                            homeBaseVal: 1
                        })
                        break;
                    case '2':
                        this.setState({
                            officeBaseVal: 1,
                            homeBaseVal: 1
                        })
                        break;
                    case '3':
                        this.setState({
                            officeBaseVal: 0,
                            homeBaseVal: 0
                        })
                        break;
                    default:
                        break;
                }

            }
            else {
                this.setState({
                    isLoader: false
                });
            }

        } catch (err) {
            console.log(err.message);
        }
    }

    getExpertiseApi = async () => {
        try {

            if (this._unmounted) {
                this.setState({
                    isELoader: true
                })
            }

            const headers = {
                'Authorization': sessionStorage.getItem('token'),
                //"Access-Control-Allow-Origin": '*'
            }

            const response = await apiHalper('getMainServices', 'GET', null, headers);
            const res = response.data;
            if (res.status) {
                const data = jwtDecode(res.data);
                const option = Array.isArray(data) ? data.map(({ id, name }) => ({ value: id, label: name })) : [];
                if (this._unmounted) {
                    this.setState({
                        expertArr: option,
                        isELoader: false,
                    })
                }
            } else {
                if (this._unmounted) {
                    this.setState({
                        expertArr: [],
                        isELoader: false
                    })
                }
            }

        } catch (err) {
            console.log(err);
            if (this._unmounted) {
                this.setState({
                    expertArr: [],
                    isELoader: false
                })
            }
        }
    }

    handlePhone = (isvalid, val) => {
        if (!isvalid) {
            this.setState({
                mobile: val,
                mobileError: 'Please Enter Valid Mobile Number',
                mobileValid: false
            });
        } else {
            this.setState({
                mobile: val,
                mobileError: '',
                mobileValid: true
            })
        }
    }

    getCountry = (e, country) => {
        this.setState({
            countryCode: country.dialCode,
            // mobile: '',
            //mobileError: 'Mobile Number is required!',
            //mobileValid: false
        })
    }

    inputHandler = e => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        }, () => this.validationChecked(name, value));
    }

    validationChecked = (name, value) => {
        let error = this.state.formError;
        let valid = this.state.formValid;
        switch (name) {
            case 'firstname':
                valid.firstname = value.length > 0;
                error.firstname = valid.firstname ? '' : 'Firstname is required!';
                break;
            case 'lastname':
                valid.lastname = value.length > 0;
                error.lastname = valid.lastname ? '' : 'Lastname is required!';
                break;
            case 'username':
                valid.username = value.length > 0;
                error.username = valid.username ? '' : 'Username is required!';
                break;
            case 'degree':
                valid.degree = value.length > 0;
                error.degree = valid.degree ? '' : 'Degree is required!';
                break;
            case 'email':
                if (value.length > 0) {
                    if (value.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
                        valid.email = true;
                        error.email = '';
                    } else {
                        valid.email = false;
                        error.email = 'Enter a valid email!';
                    }
                } else {
                    valid.email = false;
                    error.email = 'Email is required!';
                }
                break;
            case 'password':
                if (value.length > 0) {
                    if (value.length >= 1) {
                        if (value.length >= 8) {
                            valid.password = true;
                            error.password = '';
                        } else {
                            valid.password = false;
                            error.password = 'Password must be at least 8 characters long';
                        }
                    } else {
                        valid.password = false;
                        error.password = 'Password is Required!';
                    }
                } else {
                    valid.password = true;
                    error.password = '';
                }
                break;
            default:
                break;
        };

        this.setState({
            formError: error,
            formValid: valid
        });
    }

    inputEduHandler = e => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        }, () => this.validationEduChecked(name, value));
    }

    validationEduChecked = (name, value) => {
        let error = this.state.eduFormError;
        let valid = this.state.eduFormValid;
        switch (name) {
            case 'degree':
                valid.degree = value.length > 0;
                error.degree = valid.degree ? '' : 'Degree is required!';
                break;
            case 'university':
                valid.university = value.length > 0;
                error.university = valid.university ? '' : 'University is required!';
                break;
            default:
                break;
        };

        this.setState({
            eduFormError: error,
            eduFormValid: valid
        });
    }


    updateUserD = (e) => {
        e.preventDefault();
        // console.log('working...');
    }

    submitUserProfile = async (e) => {
        try {
            // e.preventDefault();

            if (this._unmounted) {
                this.setState({
                    isUserProModal: false,
                    isUserLoader: true,
                    userError: ''
                })
            }

            const headers = {
                'Authorization': sessionStorage.getItem('token'),
                //"Access-Control-Allow-Origin": '*'
            }

            const { id } = this.props.match.params;

            const { firstname, lastname, username, email, mobile, password } = this.state;
            const mobilePreFix = mobile.split(' ');
            let mobileNum = '';

            if (mobilePreFix.length > 1) {
                if (mobilePreFix.length === 3) {
                    mobileNum = mobilePreFix[1].concat(mobilePreFix[2])
                } else {
                    mobileNum = mobilePreFix[1]
                }
            }

            let formData = new FormData();
            formData.append('profile_id', id)
            formData.append('username', username)
            formData.append('first_name', firstname)
            formData.append('last_name', lastname)
            formData.append('email', email)
            formData.append('mobile_prefix', mobilePreFix[0])
            formData.append('contactNo', mobileNum)
            formData.append('password', password)

            const response = await apiHalper('updateAgentProfile', 'POST', formData, headers);
            const res = response.data;
            if (res.status) {
                if (this._unmounted) {
                    this.setState({
                        isUserLoader: false,
                        userError: '',
                        isEdit: false
                    });
                    toster_sucess('Profile Added Successfully...');
                }
            } else {
                if (this._unmounted) {
                    this.setState({
                        isUserLoader: false,
                        userError: res.message
                    })
                    toster_error(res.message);
                }

            }

        } catch (err) {
            console.log(err.message);
            if (this._unmounted) {
                this.setState({
                    isUserLoader: false,
                    userError: err.message
                })
            }
        }
    }

    editHandle = () => {
        this.setState({
            isEdit: !this.state.isEdit
        })
    }

    openLanguage = () => {
        if (!this.state.isAddLang) {
            this.setState({
                selectLang: [],
                allLang: this.state.allLangBack,
                langLevel: []
            })
        }
        this.setState({
            isAddLang: !this.state.isAddLang
        })
    }

    getLanguages = async () => {
        try {
            const headers = {
                'Authorization': sessionStorage.getItem('token'),
               // "Access-Control-Allow-Origin": '*'
            }

            const response = await apiHalper('getLanguage', 'GET', null, headers);
            const res = response.data;
            if (res.status) {
                const data = jwtDecode(res.data);
                // console.log(data);
                const option = Array.isArray(data) ? data.map(({ id, name }) => ({ value: id, label: name })) : [];
                this.setState({
                    allLang: option,
                    allLangBack: option
                })
            } else {
                this.setState({
                    allLang: [],
                    allLangBack: []
                })
            }

        } catch (err) {
            console.log(err);
        }
    }

    getSkills = async (page, search, isPrevSearch) => {
        try {

            if (this._unmounted) {
                this.setState({
                    isSkillAPILoader: true
                })
            }

            const headers = {
                'Authorization': sessionStorage.getItem('token'),
                //"Access-Control-Allow-Origin": '*'
            }

            const { id } = this.props.match.params;

            let formData = new FormData();
            formData.append('page_no', page)
            formData.append('search', search)
            formData.append('profile_id', id)

            const response = await apiHalper('getSkills', 'POST', formData, headers);
            const res = response.data;
            if (res.status) {
                const data = jwtDecode(res.data);
                // console.log(data);
                const option = Array.isArray(data.skill_lists) ? data.skill_lists.map(({ id, name }) => ({ value: id, label: name })) : [];
                if (this._unmounted) {
                    if (isPrevSearch) {
                        this.setState({
                            allSkill: option,
                            allSkillBack: option,
                            skillsCount: page < 1 ? data.skill_count : this.state.skillsCount,
                            isSkillSLoader: option.length > 100,
                            isSkillAPILoader: false,
                        })
                    } else {
                        this.setState({
                            allSkill: [...this.state.allSkill, ...option],
                            allSkillBack: [...this.state.allSkillBack, ...option],
                            skillsCount: page < 1 ? data.skill_count : this.state.skillsCount,
                            isSkillSLoader: true,
                            isSkillAPILoader: false,
                        })
                    }
                }

            } else {
                if (this._unmounted) {
                    this.setState({
                        allSkill: [],
                        skillsCount: 0,
                        allSkillBack: [],
                        isSkillSLoader: false,
                        isSkillAPILoader: false
                    })
                }
            }

        } catch (err) {
            console.log(err);
            if (this._unmounted) {
                this.setState({
                    allSkill: [],
                    skillsCount: 0,
                    allSkillBack: [],
                    isSkillSLoader: false,
                    isSkillAPILoader: false
                })
            }
        }
    }

    handleChange = (selectedOption) => {
        const { allLangBack } = this.state;

        const newArr = allLangBack.filter(info => info.value !== selectedOption.value);

        this.setState({
            selectLang: selectedOption,
            allLang: newArr
        })
    }

    handleChange2 = selectedOption => {
        this.setState({
            langLevel: selectedOption
        })
    }

    handleChangeEdu = selectedOption => {
        this.setState({
            eduLevel: selectedOption
        })
    }

    handleExper = selectedOption => {
        this.setState({
            selectExpert: selectedOption
        })
    }

    handleExp = selectedOption => {
        this.setState({
            selectExp: selectedOption
        })
    }

    LangSubmit = async (e) => {
        try {
            e.preventDefault();
            const { selectLang, langLevel, selectedLanglist, editLang } = this.state;

            if (selectLang) {
                this.setState({
                    isLangLoader: true,
                    langErr: '',
                });

                const { id } = this.props.match.params;

                const headers = {
                    'Authorization': sessionStorage.getItem('token')
                }

                let newLangId = [];
                let newLangLevel = [];
                let isChange = false;


                if (selectedLanglist.length > 0) {
                    if (editLang !== null) {
                        const exitsID = selectedLanglist.filter(info => info.id === editLang.id);

                        if (exitsID[0].id !== selectLang.value && exitsID[0].level !== langLevel.value) {

                            isChange = true;
                            const newArr = selectedLanglist.map(info => info.id);
                            const indexLang = newArr.indexOf(exitsID[0].id);
                            newLangId = Object.assign([], newArr, { [indexLang]: selectLang.value });

                            const levelArr = selectedLanglist.map(info => info.level)
                            const indexLevel = levelArr.indexOf(exitsID[0].level);
                            newLangLevel = Object.assign([], levelArr, { [indexLevel]: langLevel.value });
                            // newLangId = selectedLanglist.filter(info => info.id !== exitsID[0].id).map(info => info.id)
                            // newLangId.push(selectLang.value)
                            // newLangLevel = selectedLanglist.filter(info => info.level !== exitsID[0].level).map(info => info.level)
                            // newLangLevel.push(langLevel.value)
                        }
                        else if (exitsID[0].id !== selectLang.value || exitsID[0].level !== langLevel.value) {
                            isChange = true;
                            // console.log(selectLang);
                            if (exitsID[0].id !== selectLang.value) {
                                console.log('lang id if')
                                // const commData1 = selectedLanglist.filter(info => info.level === exitsID[0].level)
                                // console.log(commData1)
                                // newLangId = selectedLanglist.filter(info => info.id !== exitsID[0].id).map(info => info.id)
                                // newLangId.push(selectLang.value)
                                const newArr1 = selectedLanglist.map(info => info.id);
                                const indexLang1 = newArr1.indexOf(exitsID[0].id);
                                newLangId = Object.assign([], newArr1, { [indexLang1]: selectLang.value })

                                newLangLevel = selectedLanglist.map(info => info.level)
                                // newLangLevel = selectedLanglist.filter(info => info.level !== exitsID[0].level).map(info => info.level)
                                // newLangLevel.push(commData1[0].level)

                            }


                            if (exitsID[0].level !== langLevel.value) {
                                // console.log();
                                console.log('lang value if')

                                // const commData2 = selectedLanglist.filter(info => info.level === exitsID[0].level)
                                newLangId = selectedLanglist.map(info => info.id)
                                // newLangId = selectedLanglist.filter(info => info.id !== exitsID[0].id).map(info => info.id)
                                // newLangId.push(commData2[0].id)

                                const levelArr1 = selectedLanglist.map(info => info.level)
                                const indexLevel1 = levelArr1.indexOf(exitsID[0].level);
                                newLangLevel = Object.assign([], levelArr1, { [indexLevel1]: langLevel.value });
                                // newLangLevel = selectedLanglist.filter(info => info.level !== exitsID[0].level).map(info => info.level)
                                // newLangLevel.push(langLevel.value)
                                // console.log(commData2);

                            }
                        }

                        else {
                            isChange = false;
                        }
                    } else {

                        isChange = true;

                        newLangId = selectedLanglist.map(info => info.id)
                        newLangId.push(selectLang.value)

                        newLangLevel = selectedLanglist.map(info => info.level)
                        newLangLevel.push(langLevel.value)
                    }
                }
                else {
                    isChange = true;
                    newLangId.push(selectLang.value)
                    newLangLevel.push(langLevel.value)
                }


                if (isChange) {

                    // console.log(newLangId)
                    // console.log(newLangLevel)

                    let formData = new FormData();
                    formData.append('profile_id', id)
                    formData.append('language_id', JSON.stringify(newLangId))
                    formData.append('level', JSON.stringify(newLangLevel))

                    const response = await apiHalper('addProfileLanguage', 'POST', formData, headers);
                    if (response.data.status) {
                        const data = jwtDecode(response.data.data);
                        // console.log(data);
                        if (this._unmounted) {
                            this.setState({
                                selectedLanglist: data,
                                isLangLoader: false,
                                langErr: '',
                                isAddLang: false
                            });
                        }

                        toster_sucess('Language Added Successfully...');

                    } else {
                        if (this._unmounted) {
                            this.setState({
                                isLangLoader: false,
                                isAddLang: true
                            });
                        }

                        toster_error(response.data.message)
                    }
                } else {
                    if (this._unmounted) {
                        this.setState({
                            isLangLoader: false,
                            isAddLang: false
                        });
                    }
                }
            }
        }
        catch (err) {
            console.log(err.message);
            if (this._unmounted) {
                this.setState({
                    isLangLoader: false,
                    isAddLang: false
                });
            }
        }
    }

    ToggleExpert = () => {
        if (!this.state.isExpertise) {
            this.setState({
                selectExpert: null,
                selectExp: null
            })
        }
        this.setState({
            isExpertise: !this.state.isExpertise
        })
    }
    expertSubmit = async (e) => {
        try {
            e.preventDefault();

            this.setState({
                isESLoader: true,
                expErr: '',
            });


            // const { id } = this.props.match.params;

            // const headers = {
            //     'Authorization': sessionStorage.getItem('token')
            // }

            // let formData = new FormData();
            // formData.append('profile_id', id)
            // formData.append('language_id', JSON.stringify(newLangId))
            // formData.append('level', JSON.stringify(newLangLevel))

            // const response = await apiHalper('addProfileLanguage', 'POST', formData, headers);
            // if (response.data.status) {
            //     const data = jwtDecode(response.data.data);
            //     // console.log(data);
            //     this.setState({
            //         agentSkills: data,
            //         isESLoader: false,
            //         expErr: '',
            //         isExpertise: false
            //     });
            //     toster_sucess('Language Added Successfully...');

            // } else {
            //     this.setState({
            //         isESLoader: false,
            //         isExpertise: true
            //     });
            // }

        } catch (err) {
            console.log(err.message);
            if (this._unmounted) {
                this.setState({
                    isESLoader: false,
                    isExpertise: true
                });
            }
        }
    }


    renderLangu = (data, i) => {
        switch (data.level) {
            case 0:
                return <li key={i}>{data.name} <span>Basic <span className="hover_block"><button type="button" className="btn_edi" onClick={() => this.langEditMod(data)}></button>{i > 0 ? <button type="button" className="btn_del" onClick={() => this.delLangMod(data)}></button> : null}</span></span></li>;
            case 1:
                return <li key={i}>{data.name} <span>Conversational <span className="hover_block"><button type="button" className="btn_edi" onClick={() => this.langEditMod(data)}></button>{i > 0 ? <button type="button" className="btn_del" onClick={() => this.delLangMod(data)}></button> : null}</span></span></li>;
            case 2:
                return <li key={i}>{data.name} <span>Fluent <span className="hover_block"><button type="button" className="btn_edi" onClick={() => this.langEditMod(data)}></button>{i > 0 ? <button type="button" className="btn_del" onClick={() => this.delLangMod(data)}></button> : null}</span></span></li>;
            case 3:
                return <li key={i}>{data.name} <span>Native <span className="hover_block"><button type="button" className="btn_edi" onClick={() => this.langEditMod(data)}></button>{i > 0 ? <button type="button" className="btn_del" onClick={() => this.delLangMod(data)}></button> : null}</span></span></li>;
            default:
                return null;
        }
    }

    langEditMod = (data) => {
        const { allLangBack } = this.state;
        const newArr = allLangBack.filter(info => info.value !== data.id);
        this.setState({
            selectLang: { label: data.name, value: data.id },
            isAddLang: true,
            editLang: data,
            allLang: newArr
        })

        switch (data.level) {
            case 0:
                this.setState({ langLevel: { label: 'Basic', value: data.level } })
                break;
            case 1:
                this.setState({ langLevel: { label: 'Conversational', value: data.level } })
                break;
            case 2:
                this.setState({ langLevel: { label: 'Fluent', value: data.level } })
                break;
            case 3:
                this.setState({ langLevel: { label: 'Native', value: data.level } })
                break;
            default:
                break;
        }
    }

    delLangMod = async (data) => {
        try {
            const { selectedLanglist } = this.state;
            const { id } = this.props.match.params;
            const headers = {
                'Authorization': sessionStorage.getItem('token'),
               //"Access-Control-Allow-Origin": '*'
            }

            let newLangId = []
            let newLangLevel = []
            let deleteArr = []
            // console.log(selectedLanglist)
            if (selectedLanglist.length > 0) {
                deleteArr = selectedLanglist.filter(info => info.id !== data.id)
                newLangId = deleteArr.map(delData => delData.id)
                newLangLevel = selectedLanglist.filter(info => info.level !== data.level).map(delData => delData.level)
            }

            let formData = new FormData();
            formData.append('profile_id', id)
            formData.append('language_id', JSON.stringify(newLangId))
            formData.append('level', JSON.stringify(newLangLevel))

            const response = await apiHalper('addProfileLanguage', 'POST', formData, headers);
            const res = response.data;

            if (res.status) {
                this.setState({
                    selectedLanglist: deleteArr
                })
            }

        } catch (err) {
            console.log(err);
        }
    }

    renderSkills = (data, i) => {
        // console.log(i);
        // { label: 'Basic', value: 0 },
        // { label: 'Conversational', value: 1 },
        // { label: 'Fluent', value: 2 },
        // { label: 'Native', value: 3 }
        switch (data.rating) {
            case 0:
                return <li key={i}>{data.name} <span>Basic <span className="hover_block"><button type="button" className="btn_edi" onClick={() => this.skillsEditMod(data)}></button>{i > 0 ? <button type="button" className="btn_del" onClick={() => this.skillsDelete(data)}></button> : null}</span></span></li>;
            case 1:
                return <li key={i}>{data.name} <span>Conversational <span className="hover_block"><button type="button" className="btn_edi" onClick={() => this.skillsEditMod(data)}></button>{i > 0 ? <button type="button" className="btn_del" onClick={() => this.skillsDelete(data)}></button> : null}</span></span></li>;
            case 2:
                return <li key={i}>{data.name} <span>Fluent <span className="hover_block"><button type="button" className="btn_edi" onClick={() => this.skillsEditMod(data)}></button>{i > 0 ? <button type="button" className="btn_del" onClick={() => this.skillsDelete(data)}></button> : null}</span></span></li>;
            case 3:
                return <li key={i}>{data.name} <span>Native <span className="hover_block"><button type="button" className="btn_edi" onClick={() => this.skillsEditMod(data)}></button>{i > 0 ? <button type="button" className="btn_del" onClick={() => this.skillsDelete(data)}></button> : null}</span></span></li>;
            default:
                return null;
        }
    }

    skillsEditMod = (data) => {
        console.log(data);
        this.setState({
            isSkillsO: true,
            selectSkills: { label: data.name, value: data.id },
            editSkill: data
        });

        switch (data.rating) {
            case 0:
                this.setState({ sSkillsLevel: { label: 'Basic', value: 0 } })
                break;
            case 1:
                this.setState({ sSkillsLevel: { label: 'Conversational', value: 1 } })
                break;
            case 2:
                this.setState({ sSkillsLevel: { label: 'Fluent', value: 2 } })
                break;
            case 3:
                this.setState({ sSkillsLevel: { label: 'Native', value: 3 } })
                break;
            default:
                break;
        }

        if (this.state.allSkillBack.length === 0) this.getSkills(1, '', false);
    }

    experTEditMod = (data) => {
        if (this.state.expertArr.length === 0) this.getExpertiseApi();

        let selectExpe = null;

        switch (data.length) {
            case 0:
                selectExpe = { label: 'Less than 1 year', value: 0 }
                break;
            case 1:
                selectExpe = { label: '1-3 years', value: 1 }
                break;
            case 2:
                selectExpe = { label: '4-6 years', value: 2 }
                break;
            case 3:
                selectExpe = { label: '7-9 years', value: 3 }
                break;
            case 4:
                selectExpe = { label: '10-12 years', value: 4 }
                break;
            case 5:
                selectExpe = { label: '13-15 years', value: 5 }
                break;
            case 6:
                selectExpe = { label: '16-18 years', value: 6 }
                break;
            case 7:
                selectExpe = { label: '19-21 years', value: 7 }
                break;
            case 8:
                selectExpe = { label: '22-24 years', value: 8 }
                break;
            case 9:
                selectExpe = { label: '25-27 years', value: 9 }
                break;
            case 10:
                selectExpe = { label: '28-30 years', value: 10 }
                break;
            case 11:
                selectExpe = { label: '31+ years', value: 11 }
                break;
            default:
                break;
        }

        this.setState({
            isExpertise: true,
            selectExpert: { value: data.id, label: data.name },
            selectExp: selectExpe,
            editExpert: data
        })
        // console.log(data);
    }

    expRender = (data, i) => {
        const d = new Date(data.start_date);
        const l = new Date(data.end_date);
        if (data.company_name !== null) {
            return <li key={i}>{data.company_name}
                <span>{d.getFullYear()} - {data.is_current > 0 ? "Present" : l.getFullYear()}
                    <span className="hover_block">
                        <button type="button" className="btn_edi"></button>
                        <button type="button" className="btn_del"></button>
                    </span>
                </span>
            </li>
        }
    }

    edcucaRender = (data, i) => {
        const d = new Date(data.start_date);
        const l = new Date(data.end_date);
        return <li key={i}>{data.degree}
            <span>{d.getFullYear()} - {l.getFullYear()}
                <span className="hover_block">
                    <button type="button" className="btn_edi"></button>
                    <button type="button" className="btn_del" onClick={() => this.delEduction(data)}></button>
                </span>
            </span>
        </li>
    }

    headlineInput = (e) => {
        const { value } = e.target;
        this.setState({
            headline: value
        })
    }
    summaryInput = (e) => {
        const { value } = e.target;
        this.setState({
            summary: value
        })
    }

    toggleEditButton = (name) => {
        switch (name) {
            case 'headline':
                this.setState({
                    isHeadline: !this.state.isHeadline
                });
                break;
            case 'summary':
                this.setState({
                    isSummary: !this.state.isSummary
                });
                break;
            case 'degree':
                this.setState({
                    degree: !this.state.degree
                });
                break;
            default:
                break;
        }
    }

    HeadlineSubmit = (e) => {
        e.preventDefault();
    }

    summarySubmit = (e) => {
        e.preventDefault();
    }

    skillsEditBlock = () => {
        let skillView = this.state.isSkillsO;
        if (this.state.isSkillsO) {
            skillView = false
        } else {
            skillView = true;
        }

        if (!skillView) {
            this.setState({
                selectSkills: null,
                sSkillsLevel: null
            })
        }
        const { pageSkill, searchSkill, isPrevSearchSkill } = this.state;
        if (skillView) {
            if (this.state.allSkillBack.length === 0) {
                this.getSkills(pageSkill, searchSkill, isPrevSearchSkill);
            }
        }
        this.setState({
            isSkillsO: skillView
        })
    }

    handleSkill = selectedOption => {
        // const { pageSkill, searchSkill, isPrevSearchSkill } = this.state;
        // this.getSkills(pageSkill, searchSkill, isPrevSearchSkill);
        this.setState({
            selectSkills: selectedOption
        })
    }
    handleSLevel = selectedOption => {
        this.setState({
            sSkillsLevel: selectedOption
        })
    }

    skillsDelete = async (data) => {
        try {

            const { agentSkills } = this.state;

            const newDeteleArr = agentSkills.filter(info => info.id !== data.id);
            const newSkilId = newDeteleArr.map(info => info.id);
            const newSkillLevel = newDeteleArr.map(info => info.rating);

            const { id } = this.props.match.params;

            const headers = {
                'Authorization': sessionStorage.getItem('token')
            }

            let formData = new FormData();
            formData.append('profile_id', id)
            formData.append('skill_id', JSON.stringify(newSkilId))
            formData.append('rating', JSON.stringify(newSkillLevel))

            const response = await apiHalper('addProfileSkills', 'POST', formData, headers);

            if (response.data.status) {
                const { allSkill } = this.state;
                const decode = jwtDecode(response.data.data);
                let remainSkills = [];
                if (decode.length > 0) {
                    for (let index = 0; index < decode.length; index++) {
                        remainSkills = allSkill.filter(info => info.value !== decode[index].id);
                    }
                }
                // console.log(data);
                if (this._unmounted) {
                    this.setState({
                        agentSkills: decode,
                        allSkill: remainSkills
                    });
                }

                toster_sucess('Skills Delete Successfully...');

            } else {
                // if (this._unmounted) {
                //     this.setState({
                //         isSLoader: false,
                //         skillErr: '',
                //         isSkillsO: true
                //     });
                // }

                toster_error(response.data.message)
            }

        } catch (err) {
            console.log(err.message);
        }
    }

    skillsSubmit = async (e) => {
        try {
            e.preventDefault();

            const { agentSkills, editSkill, selectSkills, sSkillsLevel } = this.state;

            if (this._unmounted) {
                this.setState({
                    isSLoader: true,
                    skillErr: ''
                })
            }

            let newSkilId = []
            let newSkillLevel = [];
            let isChange = false;


            if (agentSkills.length > 0) {
                if (editSkill !== null) {
                    const exitsID = agentSkills.filter(info => info.id === editSkill.id);

                    if (exitsID[0].id !== selectSkills.value && exitsID[0].rating !== sSkillsLevel.value) {

                        isChange = true;
                        const newArr = agentSkills.map(info => info.id);
                        const indexLang = newArr.indexOf(exitsID[0].id);
                        newSkilId = Object.assign([], newArr, { [indexLang]: selectSkills.value });

                        const levelArr = agentSkills.map(info => info.rating)
                        const indexLevel = levelArr.indexOf(exitsID[0].rating);
                        newSkillLevel = Object.assign([], levelArr, { [indexLevel]: sSkillsLevel.value });
                        // newSkilId = agentSkills.filter(info => info.id !== exitsID[0].id).map(info => info.id)
                        // newSkilId.push(selectSkills.value)
                        // newSkillLevel = agentSkills.filter(info => info.level !== exitsID[0].level).map(info => info.level)
                        // newSkillLevel.push(langLevel.value)
                    }
                    else if (exitsID[0].id !== selectSkills.value || exitsID[0].rating !== sSkillsLevel.value) {
                        isChange = true;
                        // console.log(selectSkills);
                        if (exitsID[0].id !== selectSkills.value) {
                            // console.log('skills id if')
                            // const commData1 = agentSkills.filter(info => info.level === exitsID[0].level)
                            // console.log(commData1)
                            // newSkilId = agentSkills.filter(info => info.id !== exitsID[0].id).map(info => info.id)
                            // newSkilId.push(selectSkills.value)
                            const newArr1 = agentSkills.map(info => info.id);
                            const indexLang1 = newArr1.indexOf(exitsID[0].id);
                            newSkilId = Object.assign([], newArr1, { [indexLang1]: selectSkills.value })

                            newSkillLevel = agentSkills.map(info => info.rating)
                            // newSkillLevel = agentSkills.filter(info => info.level !== exitsID[0].level).map(info => info.level)
                            // newSkillLevel.push(commData1[0].level)

                        }


                        if (exitsID[0].rating !== sSkillsLevel.value) {
                            // console.log();
                            // console.log('skills value if')

                            // const commData2 = agentSkills.filter(info => info.level === exitsID[0].level)
                            newSkilId = agentSkills.map(info => info.id)
                            // newSkilId = agentSkills.filter(info => info.id !== exitsID[0].id).map(info => info.id)
                            // newSkilId.push(commData2[0].id)

                            const levelArr1 = agentSkills.map(info => info.rating)
                            const indexLevel1 = levelArr1.indexOf(exitsID[0].rating);
                            newSkillLevel = Object.assign([], levelArr1, { [indexLevel1]: sSkillsLevel.value });
                            // newSkillLevel = agentSkills.filter(info => info.level !== exitsID[0].level).map(info => info.level)
                            // newSkillLevel.push(langLevel.value)
                            // console.log(commData2);

                        }
                    }

                    else {
                        isChange = false;
                    }
                } else {

                    isChange = true;

                    newSkilId = agentSkills.map(info => info.id)
                    newSkilId.push(selectSkills.value)

                    newSkillLevel = agentSkills.map(info => info.rating)
                    newSkillLevel.push(sSkillsLevel.value)
                }
            }
            else {
                isChange = true;
                newSkilId.push(selectSkills.value)
                newSkillLevel.push(sSkillsLevel.value)
            }

            if (isChange) {
                // console.log(newSkilId)
                // console.log(newSkillLevel)

                const { id } = this.props.match.params;

                const headers = {
                    'Authorization': sessionStorage.getItem('token')
                }

                let formData = new FormData();
                formData.append('profile_id', id)
                formData.append('skill_id', JSON.stringify(newSkilId))
                formData.append('rating', JSON.stringify(newSkillLevel))

                const response = await apiHalper('addProfileSkills', 'POST', formData, headers);

                if (response.data.status) {
                    const { allSkill } = this.state;
                    const data = jwtDecode(response.data.data);
                    let remainSkills = [];
                    if (data.length > 0) {
                        for (let h = 0; h < data.length; h++) {
                            remainSkills = allSkill.filter(info => info.value !== data[h].id);
                        }
                    }
                    // console.log(data);
                    if (this._unmounted) {
                        this.setState({
                            agentSkills: data,
                            allSkill: remainSkills,
                            isSLoader: false,
                            skillErr: '',
                            isSkillsO: false,
                            sSkillsLevel: null,
                            selectSkills: null

                        });
                    }

                    toster_sucess('Skills Added Successfully...');

                } else {
                    if (this._unmounted) {
                        this.setState({
                            isSLoader: false,
                            skillErr: '',
                            isSkillsO: true
                        });
                    }

                    toster_error(response.data.message)
                }

            } else {
                if (this._unmounted) {
                    this.setState({
                        isSLoader: false,
                        isSkillsO: false
                    });
                }
            }

        } catch (err) {
            console.log(err.message);
            if (this._unmounted) {
                this.setState({
                    isSLoader: false,
                    isSkillsO: false
                });
            }
        }
    }

    officeBaseClik = (val) => {
        this.setState({
            officeBaseVal: val
        })
    }

    homeBaseClik = (val) => {
        this.setState({
            homeBaseVal: val
        })
    }

    fixedPricedCl = (val) => {
        this.setState({
            fixedPrice: val
        })
    }
    hourPricedCl = (val) => {
        this.setState({
            hourPrice: val
        })
    }
    partTimeCl = (val) => {
        this.setState({
            partTime: val
        })
    }
    fullTimeCl = (val) => {
        this.setState({
            fullTime: val
        })
    }
    freeCl = (val) => {
        this.setState({
            freeA: val
        })
    }

    fetchMoreData = () => {
        const inc = this.state.pageSkill + 1;
        if (this.state.isSkillSLoader) {
            console.log('fetch if');
            this.setState({
                pageSkill: inc
            })
            this.getSkills(inc, this.state.searchSkill, this.state.isPrevSearchSkill)
        } else {
            console.log('fetch else')
            this.setState({
                isSkillSLoader: false
            })
        }
    }

    modalCloseConfirm = () => {
        this.setState({
            isUserProModal: false
        })
    }

    modalOpenConfirm = () => {
        this.setState({
            isUserProModal: true
        })
    }

    openEduc = () => {
        if (!this.state.isEducation) {
            this.setState({
                eduLevel: null
            })
        }
        this.setState({
            isEducation: !this.state.isEducation
        })
    }

    setStartDate = (date) => {
        this.setState({
            startDate: date
        })
    }

    setEndDate = (date) => {
        this.setState({
            endDate: date
        })
    }
    delEduction = async (data) => {
        console.log(data)
        try {
            const { id } = this.props.match.params;
            const headers = {
                'Authorization': sessionStorage.getItem('token'),
                //"Access-Control-Allow-Origin": '*'
            }

            let formData = new FormData();
            formData.append('profile_id', id)
            formData.append('education_id', data.id)

            const response = await apiHalper('deleteEducations', 'POST', formData, headers);
            const res = response.data;
            if (res.status) {
                this.setState({
                    isUserLoader: false,
                })
            }

        } catch (err) {
            console.log(err);
        }
    }
    EducationSubmit = async (e) => {
        try {
            e.preventDefault();
            if (this._unmounted) {
                this.setState({
                    isUserProModal: false,
                    isUserLoader: true,
                    userError: ''
                })
            }

            const headers = {
                'Authorization': sessionStorage.getItem('token'),
               // "Access-Control-Allow-Origin": '*'
            }

            const { id } = this.props.match.params;

            const { startDate, endDate, university, degree, selectedOption } = this.state;

            let formData = new FormData();
            formData.append('profile_id', id)
            formData.append('degree', degree)
            formData.append('school_name', university)
            formData.append('start_date', moment(startDate).format('YYYY-MM-DD'))
            formData.append('end_date', moment(endDate).format('YYYY-MM-DD'))
            formData.append('level', selectedOption !== null ? selectedOption : '')

            const response = await apiHalper('addEducations', 'POST', formData, headers);
            const res = response.data;
            if (res.status) {
                if (this._unmounted) {
                    this.setState({
                        isUserLoader: false,
                        userError: '',
                        isEdit: false
                    });
                    toster_sucess('Education Detail Added Successfully...');
                }
            } else {
                if (this._unmounted) {
                    this.setState({
                        isUserLoader: false,
                        userError: res.message
                    })
                    toster_error(res.message);
                }

            }

        } catch (err) {
            console.log(err.message);
        }
    }

    render() {

        const { startDate, endDate, degree, university, eduLevel, eduFormError, eduFormValid, firstname, lastname, username, email, isEdit, mobile, mobileError, formError, formValid, isAddLang, isExpertise, allLang } = this.state;
        const disabled = !formValid.firstname || !formValid.lastname || !formValid.username || !formValid.email || !formValid.password;
        const disabledEdu = !eduFormValid.degree || !eduFormValid.university || !eduLevel || !startDate || !endDate

        const { userDetails, type } = this.props;
        // let userDetails = userDetails;
        let resume = null;
        if (userDetails !== null) {
            if (type === 'agent') {
                if (userDetails !== null) {
                    const arr = userDetails ? userDetails.resumes.split('/') : [];
                    const index = (arr.length - 1);
                    resume = arr[index];
                }
            }
        }
        const options = [
            { label: 'English', value: 0 },
            { label: 'Hindi', value: 1 },
            { label: 'Gujarati', value: 2 },
            { label: 'Marathi', value: 3 }
        ]

        const optionsLevel = [
            { label: 'Basic', value: 0 },
            { label: 'Conversational', value: 1 },
            { label: 'Fluent', value: 2 },
            { label: 'Native', value: 3 }
        ]

        const optionsEdu = [
            { label: 'Associate', value: 0 },
            { label: 'Bachelor', value: 1 },
            { label: 'Master', value: 2 },
            { label: 'Doctorate', value: 3 }
        ]

        // const optionsExpertise = [
        //     { label: 'Customer Service', value: 1 },
        //     { label: 'Sales & Marketing', value: 2 },
        //     { label: 'Accounting', value: 3 },
        //     { label: 'Data Entry & Admin', value: 4 },
        //     { label: 'Writing & Editing', value: 5 },
        //     { label: 'Video & Animation', value: 6 }
        // ]
        const optionsExp = [
            { label: 'Less than 1 year', value: 0 },
            { label: '1-3 years', value: 1 },
            { label: '4-6 years', value: 2 },
            { label: '7-9 years', value: 3 },
            { label: '10-12 years', value: 4 },
            { label: '13-15 years', value: 5 },
            { label: '16-18 years', value: 6 },
            { label: '19-21 years', value: 7 },
            { label: '22-24 years', value: 8 },
            { label: '25-27 years', value: 9 },
            { label: '28-30 years', value: 10 },
            { label: '31+ years', value: 11 }
        ]

        const confirmModalData = {
            isOpen: this.state.isUserProModal,
            modalClose: this.modalCloseConfirm,
            text: 'Update user details?',
            confirmHandler: this.submitUserProfile
        }

        return (
            <div className="tab_container">
                <div className="form_wrap">
                    <form method="POST" action="/" onSubmit={this.updateUserD}>
                        <div className="form_group divd_wrap">
                            <div className="wid_full">
                                <label className="label_form">First Name</label>
                                <input type="text" className={formError.firstname !== "" ? "form_control error_border" : "form_control"} value={firstname} name="firstname" placeholder="First Name" onChange={this.inputHandler} autoComplete="off" disabled={!isEdit} />
                                {formError.firstname !== '' ? <p className="error_text">{formError.firstname}</p> : null}
                            </div>
                            <div className="wid_full">
                                <label className="label_form">Last Name</label>
                                <input type="text" className={formError.lastname !== "" ? "form_control error_border" : "form_control"} value={lastname} name="lastname" placeholder="Last Name" onChange={this.inputHandler} autoComplete="off" disabled={!isEdit} />
                                {formError.lastname !== '' ? <p className="error_text">{formError.lastname}</p> : null}
                            </div>
                        </div>
                        <div className="form_group divd_wrap">
                            <div className="wid_full">
                                <label className="label_form">User Name</label>
                                <input type="text" className={formError.username !== "" ? "form_control error_border" : "form_control"} value={username} name="username" placeholder="User Name" onChange={this.inputHandler} autoComplete="off" disabled={!isEdit} />
                                {formError.username !== '' ? <p className="error_text">{formError.username}</p> : null}
                            </div>
                            <div className="wid_full">
                                <label className="label_form">Email</label>
                                <input type="email" className={formError.email !== "" ? "form_control error_border" : "form_control"} value={email} name="email" placeholder="Email Address" onChange={this.inputHandler} autoComplete="off" disabled={!isEdit} />
                                {formError.email !== '' ? <p className="error_text">{formError.email}</p> : null}
                            </div>
                        </div>
                        <div className="form_group divd_wrap">
                            <div className="wid_full">
                                <label className="label_form">Password</label>
                                <input type="password" className={formError.password !== "" ? "form_control error_border" : "form_control"} value={this.state.password} name="password" placeholder="New Password" onChange={this.inputHandler} autoComplete="off" disabled={!isEdit} />
                                {formError.password !== '' ? <p className="error_text">{formError.password}</p> : null}
                            </div>
                            <div className="wid_full">
                                <label className="label_form">Mobile</label>
                                <IntlTelInput onPhoneNumberChange={this.handlePhone} onSelectFlag={this.getCountry} value={mobile} disabled={!isEdit} inputClassName={mobileError !== '' ? "form_control error_border" : "form_control"} />
                                {mobileError !== '' ? <p className="error_text">{mobileError}</p> : null}
                            </div>
                        </div>
                        {this.state.userError !== '' ? <p className="error_text">{this.state.userError}</p> : null}
                        <div className="form_btngroup">
                            {!isEdit ?
                                <div><button type="button" className="btn_edit" onClick={this.editHandle}>Edit</button></div>
                                :
                                <div>
                                    <button type="button" className="btn_save" disabled={disabled || this.state.isUserLoader} onClick={this.modalOpenConfirm}>
                                        {this.state.isUserLoader ? <img src={LoaderImg} className="small-loader" alt="loader" /> : 'Save'}
                                    </button>
                                    <button type="button" className="btn_cancel" onClick={this.editHandle}>Cancel</button>
                                </div>
                            }
                        </div>
                    </form>
                </div>

                <div className="main_prof_div">
                    {type === "agents" ? <>
                        <div className="li_vie">
                            <div className="lang_block">
                                <h4 className="title_lgng">Language <button type="button" className={isAddLang ? "btn_addimg active" : "btn_addimg"} onClick={this.openLanguage}></button></h4>
                                {!isAddLang ?
                                    <ul className="list_vie">
                                        {this.state.selectedLanglist.length > 0 ?
                                            this.state.selectedLanglist.map((data, i) => this.renderLangu(data, i))
                                            :
                                            <li>No Record Found</li>
                                        }
                                    </ul>
                                    :
                                    <form method="POST" action="#javascript:void(0)" onSubmit={this.LangSubmit}>
                                        <div className="form_group">
                                            <div className="div_2">
                                                <Select value={this.state.selectLang} placeholder={"Select Language"} onChange={this.handleChange} options={allLang} />
                                            </div>
                                            <div className="div_2">
                                                <Select value={this.state.langLevel} placeholder={"Language Level"} onChange={this.handleChange2} options={optionsLevel} />
                                            </div>
                                        </div>
                                        <div className="form_group">
                                            <button type="submit" className="btn_save" disabled={this.state.isLangLoader}>{this.state.isLangLoader ? <img src={LoaderImg} className="small-loader" alt="loader" /> : "Save"}</button>
                                            <button type="button" className="btn_cancel" onClick={this.openLanguage}>Cancel</button>
                                        </div>
                                    </form>
                                }
                            </div>
                        </div>

                        <div className="li_vie">
                            <div className="lang_block">
                                {/* <button type="button" className={isExpertise ? "btn_addimg active" : "btn_addimg"} onClick={this.ToggleExpert}></button> */}
                                <h4 className="title_lgng">Expertise </h4>
                                {!isExpertise ?
                                    <ul className="list_vie">
                                        {userDetails ?
                                            userDetails.expertise.name !== null && userDetails.expertise.name !== undefined ?
                                                <li>{userDetails.expertise.name}
                                                    <span>{
                                                        this.state.optionsExp.map(info => info.value === userDetails.expertise.length ? info.label : null)
                                                    }
                                                        {/* <button type="button" className="btn_del"></button> */}
                                                        <span className="hover_block"><button type="button" className="btn_edi" onClick={() => this.experTEditMod(userDetails.expertise)}></button></span></span>
                                                </li>
                                                :
                                                <li>No Record Found</li>
                                            :
                                            <li>No Record Found</li>
                                        }
                                    </ul>
                                    :
                                    <form method="POST" action="#javascript:void(0)" onSubmit={this.expertSubmit}>
                                        <div className="form_group">
                                            <Select value={this.state.selectExpert} placeholder={"Select Expertise"} isDisabled={this.state.isELoader} isLoading={this.state.isELoader} onChange={this.handleExper} options={this.state.expertArr} />
                                        </div>
                                        {this.state.selectExpert !== null ?
                                            <div className="form_group">
                                                <Select value={this.state.selectExp} placeholder={"Select Experience"} onChange={this.handleExp} options={this.state.optionsExp} />
                                            </div>
                                            :
                                            null
                                        }
                                        {this.state.selectExp !== null ?
                                            <div className="form_group mar_t15">
                                                <button type="submit" className="btn_save">Save</button>
                                                <button type="button" className="btn_cancel" onClick={this.ToggleExpert}>Cancel</button>
                                            </div>
                                            :
                                            null
                                        }
                                    </form>
                                }
                            </div>
                        </div>
                        <div className="li_vie">
                            <div className="lang_block">
                                <h4 className="title_lgng">Skills <button type="button" className={this.state.isSkillsO ? "btn_addimg active" : "btn_addimg"} onClick={this.skillsEditBlock}></button></h4>
                                {!this.state.isSkillsO ?
                                    <ul className="list_vie">
                                        {userDetails ?
                                            Array.isArray(this.state.agentSkills) && this.state.agentSkills.length > 0 ?
                                                this.state.agentSkills.map((data, i) => this.renderSkills(data, i))
                                                :
                                                <li>No Record Found</li>
                                            :
                                            <li>No Record Found</li>
                                        }

                                    </ul>
                                    :
                                    <form method="POST" action="#javascript:void(0)" onSubmit={this.skillsSubmit}>
                                        <div className="form_group">
                                            <div className="div_2">
                                                {/* menuIsOpen={true} onBlur={this.searchSkills} defaultInputValue={this.state.searchSkill} onInputChange={this.skillSearchHandler} filterOption={this.searchSkills}  */}
                                                <Select className="skill-selec" onMenuScrollToBottom={this.fetchMoreData} value={this.state.selectSkills} placeholder={"Select Skills"} onChange={this.handleSkill} options={this.state.allSkill} isDisabled={this.state.isSkillAPILoader} isLoading={this.state.isSkillAPILoader} />
                                            </div>
                                            <div className="div_2">
                                                <Select value={this.state.sSkillsLevel} placeholder={"Skills Level"} onChange={this.handleSLevel} options={optionsLevel} />
                                            </div>
                                        </div>
                                        <div className="form_group">
                                            <button type="submit" className="btn_save">Save</button>
                                            <button type="button" className="btn_cancel" onClick={this.skillsEditBlock}>Cancel</button>
                                        </div>
                                    </form>
                                }
                            </div>
                        </div>
                    </>
                        : null}
                    <div className="li_vie">
                        <div className="lang_block">
                            <form action="#" method="POST" onSubmit={this.HeadlineSubmit}>
                                <h4 className="title_lgng">Professional Headline <button type="button" className={this.state.isHeadline ? "btn_addimg active" : "btn_addimg"} onClick={() => this.toggleEditButton('headline')}></button></h4>
                                <div className="hed_input">
                                    <input type="text" className="form_control" value={this.state.headline} onChange={this.headlineInput} disabled={!this.state.isHeadline} />
                                </div>
                                {this.state.isHeadline ?
                                    <div className="form_group mar_t15">
                                        <button type="submit" className="btn_save">Save</button>
                                        <button type="button" className="btn_cancel" onClick={() => this.toggleEditButton('headline')}>Cancel</button>
                                    </div>
                                    :
                                    null
                                }
                            </form>
                        </div>
                    </div>
                    <div className="li_vie">
                        <div className="lang_block">
                            <form action="#" method="POST" onSubmit={this.summarySubmit}>
                                <h4 className="title_lgng">profile Summary <button type="button" className={this.state.isSummary ? "btn_addimg active" : "btn_addimg"} onClick={() => this.toggleEditButton('summary')}></button></h4>
                                <div className="hed_input">
                                    {/* <p className="form_control">Test</p> */}
                                    <textarea className="form_control2 textarea" value={this.state.summary} onChange={this.summaryInput} disabled={!this.state.isSummary}></textarea>
                                </div>
                                {this.state.isSummary ?
                                    <div className="form_group mar_t15">
                                        <button type="submit" className="btn_save">Save</button>
                                        <button type="button" className="btn_cancel" onClick={() => this.toggleEditButton('summary')}>Cancel</button>
                                    </div>
                                    :
                                    null
                                }
                            </form>
                        </div>
                    </div>

                    {type === "agents" ? <>
                        <div className="li_vie">
                            <div className="lang_block">
                                <h4 className="title_lgng">Employment History <button type="button" className="btn_addimg"></button></h4>
                                {!this.state.isEHistory ?
                                    <ul className="list_vie">
                                        {userDetails ?
                                            Array.isArray(userDetails.experiences) && userDetails.experiences.length > 0 ?
                                                userDetails.experiences.map((data, i) => this.expRender(data, i))
                                                :
                                                <li>No Record Found</li>
                                            :
                                            <li>No Record Found</li>
                                        }
                                    </ul>
                                    :
                                    <form method="POST" action="#javascript:void(0)" onSubmit={this.HistorySubmit}>
                                        <div className="form_group">
                                            <input type="text" value={this.state.selectExp} placeholder={"Select Experience"} onChange={this.handleExp} options={optionsExp} />
                                        </div>
                                        <div className="form_group">
                                            <div className="div_2">
                                                <Select value={this.state.selectLang} placeholder={"Select Language"} onChange={this.handleChange} options={options} />
                                            </div>
                                            <div className="div_2">
                                                <Select value={this.state.langLevel} placeholder={"Language Level"} onChange={this.handleChange2} options={optionsLevel} />
                                            </div>
                                        </div>
                                        <div className="form_group">
                                            <button type="submit" className="btn_save">Save</button>
                                            <button type="button" className="btn_cancel" onClick={this.openLanguage}>Cancel</button>
                                        </div>
                                    </form>
                                }
                            </div>
                        </div>
                        <div className="li_vie">
                            <div className="lang_block">
                                <h4 className="title_lgng">Education <button type="button" className={this.state.isEducation ? "btn_addimg active" : "btn_addimg"} onClick={this.openEduc}></button></h4>
                                {!this.state.isEducation ?
                                    <ul className="list_vie">
                                        {userDetails ?
                                            Array.isArray(userDetails.educations) && userDetails.educations.length > 0 ?
                                                userDetails.educations.map((data, i) => this.edcucaRender(data, i))
                                                :
                                                <li>No Record Found</li>
                                            :
                                            <li>No Record Found</li>
                                        }
                                    </ul>
                                    :
                                    <form method="POST" action="/" onSubmit={this.EducationSubmit}>
                                        <div className="form_group">
                                            <div className="div_2">
                                                <input type="text" className={eduFormError.degree !== "" ? "form_control error_border" : "form_control"} name="degree" value={degree} onChange={this.inputEduHandler} placeholder="Enter Degree" disabled={isEdit} autoComplete="off" />
                                                {eduFormError.degree !== '' ? <p className="error_text">{eduFormError.degree}</p> : null}
                                            </div>
                                            <div className="div_2">
                                                <input type="text" className={eduFormError.university !== "" ? "form_control error_border" : "form_control"} name="university" value={university} onChange={this.inputEduHandler} placeholder="Enter university" disabled={isEdit} autoComplete="off" />
                                                {eduFormError.university !== '' ? <p className="error_text">{eduFormError.university}</p> : null}
                                            </div>
                                            <div className="div_2">
                                                <Select value={this.state.eduLevel} placeholder={"Select Education"} onChange={this.handleChangeEdu} options={optionsEdu} />
                                            </div>
                                            <div className="div_2 flex column-gap-15 black-dp">
                                                <DatePicker placeholderText="Select Start Date" selected={startDate} minDate={new Date("2018-01-01")} maxDate={new Date()} onChange={date => this.setStartDate(date)} dateFormat="yyyy-MM-dd" />
                                                <DatePicker placeholderText="Select End Date" selected={endDate} onChange={date => this.setEndDate(date)} minDate={startDate} maxDate={new Date()} endDate={endDate} dateFormat="yyyy-MM-dd" />
                                            </div>
                                        </div>
                                        <div className="form_group">
                                            <button type="submit" className="btn_save" disabled={disabledEdu || this.state.isLangLoader}>{this.state.isLangLoader ? <img src={LoaderImg} className="small-loader" alt="loader" /> : "Save"}</button>
                                            <button type="button" className="btn_cancel" onClick={this.openEduc}>Cancel</button>
                                        </div>
                                    </form>
                                }
                            </div>
                        </div>
                        <div className="li_vie">
                            <div className="lang_block">
                                <h4 className="title_lgng">Resume Only visible to you</h4>
                                <ul className="list_vie">
                                    {userDetails ?
                                        userDetails.resumes !== null ?
                                            <li>{userDetails.resumes} <img src={Resume_icon} alt="resume" />{resume}</li>
                                            :
                                            <li>No Record Found</li>
                                        :
                                        <li>No Record Found</li>
                                    }
                                    {/* <li>BE <span>2017 - 2019</span></li> */}
                                </ul>
                            </div>
                        </div>
                        <div className="li_vie">
                            <div className="lang_block">
                                <h4 className="title_lgng">Type of work</h4>

                                {userDetails !== null ?
                                    <ul className="list_vie no-hover">
                                        <li>Office-base
                                        <span>
                                                <button type="button" className={this.state.officeBaseVal === 0 ? "btn_radiuo no active" : "btn_radiuo no"} onClick={() => this.officeBaseClik(0)}>No</button>
                                                <button type="button" className={this.state.officeBaseVal === 1 ? "btn_radiuo yes active" : "btn_radiuo yes"} onClick={() => this.officeBaseClik(1)}>Yes</button>
                                            </span>
                                        </li>
                                        <li>Home-base
                                        <span>
                                                <button type="button" className={this.state.homeBaseVal === 0 ? "btn_radiuo no active" : "btn_radiuo no"} onClick={() => this.homeBaseClik(0)}>No</button>
                                                <button type="button" className={this.state.homeBaseVal === 1 ? "btn_radiuo yes active" : "btn_radiuo yes"} onClick={() => this.homeBaseClik(1)}>Yes</button>
                                            </span>
                                        </li>
                                    </ul>
                                    :
                                    <li>No Record Found</li>
                                }

                            </div>
                        </div>
                        <div className="li_vie">
                            <div className="lang_block">
                                <h4 className="title_lgng">Availability</h4>
                                <ul className="list_vie no-hover">
                                    <li>Fixed-price
                                    <span>
                                            <button type="button" className={this.state.fixedPrice === 0 ? "btn_radiuo no active" : "btn_radiuo no"} onClick={() => this.fixedPricedCl(0)}>No</button>
                                            <button type="button" className={this.state.fixedPrice === 1 ? "btn_radiuo yes active" : "btn_radiuo yes"} onClick={() => this.fixedPricedCl(1)}>Yes</button>
                                        </span>
                                    </li>
                                    <li>Hourly ($/hour)
                                    <span>
                                            <button type="button" className={this.state.hourPrice === 0 ? "btn_radiuo no active" : "btn_radiuo no"} onClick={() => this.hourPricedCl(0)}>No</button>
                                            <button type="button" className={this.state.hourPrice === 1 ? "btn_radiuo yes active" : "btn_radiuo yes"} onClick={() => this.hourPricedCl(1)}>Yes</button>
                                        </span>
                                    </li>
                                    <li>Part-time (20hrs/wk)
                                    <span>
                                            <button type="button" className={this.state.partTime === 0 ? "btn_radiuo no active" : "btn_radiuo no"} onClick={() => this.partTimeCl(0)}>No</button>
                                            <button type="button" className={this.state.partTime === 1 ? "btn_radiuo yes active" : "btn_radiuo yes"} onClick={() => this.partTimeCl(1)}>Yes</button>
                                        </span>
                                    </li>
                                    <li>Full-time (40hrs/wk)
                                    <span>
                                            <button type="button" className={this.state.fullTime === 0 ? "btn_radiuo no active" : "btn_radiuo no"} onClick={() => this.fullTimeCl(0)}>No</button>
                                            <button type="button" className={this.state.fullTime === 1 ? "btn_radiuo yes active" : "btn_radiuo yes"} onClick={() => this.fullTimeCl(1)}>Yes</button>
                                        </span>
                                    </li>
                                    <li>Free
                                    <span>
                                            <button type="button" className={this.state.freeA === 0 ? "btn_radiuo no active" : "btn_radiuo no"} onClick={() => this.freeCl(0)}>No</button>
                                            <button type="button" className={this.state.freeA === 1 ? "btn_radiuo yes active" : "btn_radiuo yes"} onClick={() => this.freeCl(1)}>Yes</button>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </> : null}
                </div>
                <ConfirmModal modalData={confirmModalData} />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    userDetails: state.users.userDetails
})

export default withRouter(connect(mapStateToProps)(ProfileTab));
